var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useLayoutEffect, useRef } from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import * as S from './styled';
export const TooltipStatic = ({ children }) => {
    return React.createElement(Manager, null, children);
};
const TooltipStaticReference = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Reference, null, ({ ref }) => (React.createElement("div", Object.assign({ ref: ref }, props), children))));
};
const TooltipStaticBody = ({ placement = 'bottom', strategy = 'absolute', offset = [0, 10], withPadding = true, fluid = false, children, }) => {
    const positionUpdateRef = useRef(null);
    useLayoutEffect(() => {
        if (positionUpdateRef.current) {
            positionUpdateRef.current();
        }
    }, [children]);
    const renderTooltip = ({ ref, style, placement: dataPlacement, update }) => {
        positionUpdateRef.current = update;
        return (React.createElement(S.Tooltip, { ref: ref, "$placement": dataPlacement, "$withPadding": withPadding, "$fluid": fluid, style: style, role: "tooltip" }, children));
    };
    return (React.createElement(Popper, { placement: placement, strategy: strategy, modifiers: [
            { name: 'offset', options: { offset } },
            { name: 'preventOverflow', options: { padding: 8 } },
        ] }, renderTooltip));
};
TooltipStatic.Body = TooltipStaticBody;
TooltipStatic.Reference = TooltipStaticReference;
//# sourceMappingURL=TooltipStatic.js.map